module.exports = __webpack_public_path__ + "files/885f0ed62b769ea124d5b659891776a1.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-1.png
// module id = 525
// module chunks = 76